/*************************************************/
/* DOWNLOADS                                     */
/*************************************************/

export function downloads() {
    const selectClass = '.media-content__download-select';
    const selectOpenModifier = 'media-content__download-select--open';
    const triggerClass = '.media-content__download-trigger';
    const optionsClass = '.media-content__download-options';
    const optionClass = '.media-content__download-option';
    const labelClass = '.media-content__download-label';
    const flagClass = '.media-content__download-flag';
    const textClass = 'media-content__download-text';
    const openModifier = 'media-content__download-options--open';

    const init = () => {
        const selects = document.querySelectorAll(selectClass);

        selects.forEach(select => {
            const id = select.dataset.id;
            const trigger = select.querySelector(triggerClass);
            const optionsContainer = select.querySelector(optionsClass);
            const label = select.querySelector(labelClass);
            const downloadBtn = document.getElementById('downloadBtn-' + id);

            // Toggle Dropdown
            trigger.addEventListener('click', (e) => {
                e.stopPropagation();
                
                // Close any other open download selects
                document.querySelectorAll(selectClass).forEach(otherSelect => {
                    if (otherSelect !== select) {
                        otherSelect.classList.remove(selectOpenModifier);
                        otherSelect.querySelector(optionsClass)?.classList.remove(openModifier);
                    }
                });
                
                // Toggle classes on both the wrapper and the options container
                select.classList.toggle(selectOpenModifier);
                optionsContainer.classList.toggle(openModifier);
            });

            // Handle Selection
            optionsContainer.addEventListener('click', (e) => {
                const option = e.target.closest(optionClass);
                if (!option) return;

                const url = option.dataset.url;
                const lang = option.dataset.lang;
                const flagHtml = option.querySelector(flagClass)?.outerHTML || '';

                label.innerHTML = `${flagHtml} <span class="${textClass}">${lang}</span>`;

                if (url && downloadBtn) {
                    downloadBtn.href = url;
                    downloadBtn.style.display = 'flex';
                }

                // Close everything
                select.classList.remove(selectOpenModifier);
                optionsContainer.classList.remove(openModifier);
            });
        });

        // Close when clicking outside
        document.addEventListener('click', () => {
            document.querySelectorAll(selectClass).forEach(s => s.classList.remove(selectOpenModifier));
            document.querySelectorAll(optionsClass).forEach(opt => opt.classList.remove(openModifier));
        });
    };

    init();
}